const { defaultsDeep } = require('lodash');

require('jquery');

$(document).ready(function () {
    let ajaxRoute = $('#ajax-route').val();

    var triggerTabList = [].slice.call(document.querySelectorAll('#myTab a'))
    triggerTabList.forEach(function (triggerEl) {
        var tabTrigger = new bootstrap.Tab(triggerEl)

        triggerEl.addEventListener('click', function (event) {
            event.preventDefault()
            tabTrigger.show()
        })
    })


    /**************************functions**********************************/
    let pMonthsShower = $('.months-shower');
    let monthPercentage = [];

    function c(passed_month, passed_year, calNum) {
        const service = 'service_' + $('.status-select-date').val()
        var calendar = calNum == 0 ? calendars.cal1 : calendars.cal2;
        if (calNum == 0) {
            var calendar = calendars.cal1
        } else if (calNum == 1) {
            var calendar = calendars.cal2
        } else {
            var calendar = calendars.cal3
        }
        makeWeek(calendar.weekline);
        calendar.datesBody.empty();
        var calMonthArray = makeMonthArray(passed_month, passed_year);
        var r = 0;
        var u = false;
        while (!u) {
            if (daysArray[r] == calMonthArray[0].weekday) {
                u = true
            } else {
                calendar.datesBody.append('<div class="blank"></div>');
                r++;
            }
        }
        for (var cell = 0; cell < 42 - r; cell++) { // 42 date-cells in calendar
            if (cell >= calMonthArray.length) {
                calendar.datesBody.append('<div class="blank"></div>');
            } else {
                var shownDate = calMonthArray[cell].day;
                // Later refactiroing -- iter_date not needed after "today" is found
                var iter_date = new Date(passed_year, passed_month, shownDate);

                //Nel
                let b = Number.parseInt(passed_month)
                var php_date = passed_year + '-' + String(++b).padStart(2, "0") + '-' + String(shownDate).padStart(2, "0")
                if (
                    (
                        (shownDate != today.getDate() && passed_month == today.getMonth())
                        || passed_month != today.getMonth()
                    )
                    && iter_date > today) {
                    //Nel: la class normale c'est	'past-date'
                    var m = '<div data-date="' + php_date + '" class="past-date">';
                } else {
                    // Nel: la class normale c'est	'today'
                    // Nel: ici remplissage des jours du mois
                    // console.log(monthPercentage[service], shownDate, php_date)
                    // var m = checkToday(iter_date) ? '<span data-date="' + php_date + '" class="oday status-day">' : "<span class='status-day text-success' data-date='" + php_date + "'>";
                    var m = "<span class='status-day' data-date='" + php_date + "'>";
                }
                calendar.datesBody.append(m + shownDate + "</span>");
            }
        }

        calendar.calHeader.find("h2").text(i[passed_month] + " " + passed_year);


        /**********************Code Added by Nel*****************************/
        $('.status-day').off('click').on('click', function (e) {
            e.preventDefault()
            const btn = $(this)
            if (!btn.hasClass('text-black')) {
                const modal = $('#modal-status')

                try {
                    /*console.log(btn.attr('data-date'),
                        btn.attr('data-slug') === 'operationnel' ||
                        (btn.attr('data-slug') === 'maintenance' && (new Date(btn.attr('data-ended'))).getTime() <= (new Date(btn.attr('data-date'))).getTime())
                    );*/
                    if (
                        btn.attr('data-slug') === 'operationnel' ||
                        (btn.attr('data-slug') === 'maintenance' && (new Date(btn.attr('data-ended'))).getTime() <= (new Date(btn.attr('data-date'))).getTime())
                    ) {
                        const date = btn.attr('data-date');
                        const parts = date.split('-')
                        const str_date = parts[2] + ' ' + i[parts[1] - 1] + ' ' + parts[0]
                        modal.find('.date').text(str_date)
                        modal.find('.date-title').text('Date:')
                        modal.find('.resume').text('Aucun incident n\'a été signalé.')
                    } else {
                        const datetime = btn.attr('data-created');
                        const datetimeparts = (datetime.split(' '))
                        const date = datetimeparts[0]
                        const parts = date.split('-')
                        const str_date = parts[2] + ' ' + i[parts[1] - 1] + ' ' + parts[0] + ' à ' + datetimeparts[1]
                        modal.find('.date').text(str_date)
                        modal.find('.date-title').text('Survenu le:')
                        modal.find('.resume').html(`<span class="${btn.attr('data-color')}">${btn.attr('data-resume')}</span>`)
                        const others = JSON.parse(btn.attr('data-others'))
                        if (others.length) {
                            let list = `- <span class="${btn.attr('data-color')}">${btn.attr('data-resume')}</span><br>`
                            others.forEach(function (state) {
                                if (state.color !== 'text-success') {
                                    list += `- <span class="${state.color}">${state.resume}</span><br>`
                                }
                            })
                            modal.find('.resume').html(list)
                        }
                    }
                } catch (error) {
                }

                if (
                    // btn.attr('data-slug') === 'maintenance' ||
                    btn.attr('data-slug') === 'operationnel'
                ) {
                    modal.find('.show').attr('disabled', true)
                } else {
                    modal.find('.show').removeAttr('disabled')
                }

                modal.find('.modal-title').text($('.status-select-date option:selected').text())
                modal.find('.icon').html(
                    `<i class="fas fa-5x fa-${btn.attr('data-icon')} ${btn.attr('data-color')} mr-1"></i>`
                )
                modal.find('.panne').html(
                    `<p class="text-center h4 mb-5 ${btn.attr('data-color')}">${btn.attr('data-status')}</p>`
                )

                modal.modal('show')

                modal.find('.show').off('click').on('click', function (e) {
                    e.preventDefault()
                    const datetime = btn.attr('data-created');
                    const date = (datetime.split(' '))[0]

                    incidentLoader(btn, true, date)

                    const parts = date.split('-')
                    $('.months-shower').text(parts[2] + ' ' + i[parts[1] - 1] + ' ' + parts[0])
                    $('.status-select-list').val($('.status-select-date').val())

                    $('.nav-calendar').removeClass('active')
                    $('.panel-calendar').removeClass(['active', 'show'])
                    $('.nav-story').addClass('active')
                    $('.panel-story').addClass(['active', 'show'])
                    modal.modal('hide')
                })
            }
        })

        function loadMonthPercentageInfo() {
            let month = passed_month + '_' + passed_year
            if (
                monthPercentage[service] !== undefined &&
                monthPercentage[service][month] !== undefined
            ) {
                calendar.calHeader.find("p").text(monthPercentage[service][month].percentage)
                setDateColor(monthPercentage[service][month])
            } else {
                let month1 = parseInt(passed_month) + 1;
                $.get(ajaxRoute, {
                    serviceId: $('.status-select-date').val(),
                    percentageMonth: passed_year + '-' + month1
                }).then(function (response) {
                    if (monthPercentage[service] === undefined) {
                        monthPercentage[service] = []
                    }
                    monthPercentage[service][month] = response
                    calendar.calHeader.find("p").text(monthPercentage[service][month].percentage)

                    setDateColor(monthPercentage[service][month])
                })
            }

        }

        function setDateColor(month) {
            $('[data-date]').each(function () {
                try {
                    const date = $(this).data('date')
                    const state = month.serviceHistory[date]
                    if (state !== undefined && $(this).hasClass('status-day')) {
                        if (state.length === 0) {
                            if (month.lastStatus !== null) {
                                $(this).addClass(month.lastStatus.color)
                                $(this).attr('data-icon', month.lastStatus.icon)
                                $(this).attr('data-color', month.lastStatus.color)
                                $(this).attr('data-resume', month.lastStatus.resume)
                                $(this).attr('data-status', month.lastStatus.status)
                                $(this).attr('data-created', month.lastStatus.created_at)
                                $(this).attr('data-slug', month.lastStatus.slug)
                                $(this).attr('data-ended', month.lastStatus.end_at)
                            } else {
                                $(this).addClass('text-black')
                            }
                        } else {
                            let stateToUse = state

                            $(this).addClass(stateToUse.color)
                            $(this).attr('data-icon', stateToUse.icon)
                            $(this).attr('data-slug', stateToUse.slug)
                            $(this).attr('data-color', stateToUse.color)
                            $(this).attr('data-resume', stateToUse.resume)
                            $(this).attr('data-status', stateToUse.status)
                            $(this).attr('data-others', JSON.stringify(stateToUse.otherStates))
                            $(this).attr('data-created', stateToUse.created_at)
                            $(this).attr('data-ended', stateToUse.end_at)
                        }
                    }
                } catch (error) {
                    // console.log(error)
                }
            })
        }

        loadMonthPercentageInfo()

        $('.status-select-date').off('change').on('change', function () {
            b()
            c(month, year, 0);
            c(nextMonth, nextYear, 1);
            c(sNextMonth, sNextYear, 2);
        })

        /**********************End Code Added by Nel**************************/

        var clicked = false;
        selectDates(selected);

        clickedElement = calendar.datesBody.find('div');
        clickedElement.on("click", function () {
            clicked = $(this);
            if (clicked.hasClass('past-date')) {
                return;
            }
            var whichCalendar = calendar.name;
            // Understading which element was clicked;
            if (firstClick && secondClick) {
                thirdClicked = getClickedInfo(clicked, calendar);
                var firstClickDateObj = new Date(firstClicked.year,
                    firstClicked.month,
                    firstClicked.date);
                var secondClickDateObj = new Date(secondClicked.year,
                    secondClicked.month,
                    secondClicked.date);
                var thirdClickDateObj = new Date(thirdClicked.year,
                    thirdClicked.month,
                    thirdClicked.date);
                if (secondClickDateObj > thirdClickDateObj
                    && thirdClickDateObj > firstClickDateObj) {
                    secondClicked = thirdClicked;
                    // then choose dates again from the start :)
                    bothCals.find(".calendar_content").find("div").each(function () {
                        $(this).removeClass("selected");
                    });
                    selected = {};
                    selected[firstClicked.year] = {};
                    selected[firstClicked.year][firstClicked.month] = [firstClicked.date];
                    selected = addChosenDates(firstClicked, secondClicked, selected);
                } else { // reset clicks
                    selected = {};
                    firstClicked = [];
                    secondClicked = [];
                    firstClick = false;
                    secondClick = false;
                    bothCals.find(".calendar_content").find("div").each(function () {
                        $(this).removeClass("selected");
                    });
                }
            }
            if (!firstClick) {
                firstClick = true;
                firstClicked = getClickedInfo(clicked, calendar);
                selected[firstClicked.year] = {};
                selected[firstClicked.year][firstClicked.month] = [firstClicked.date];
            } else {
                secondClick = true;
                secondClicked = getClickedInfo(clicked, calendar);

                // what if second clicked date is before the first clicked?
                var firstClickDateObj = new Date(firstClicked.year,
                    firstClicked.month,
                    firstClicked.date);
                var secondClickDateObj = new Date(secondClicked.year,
                    secondClicked.month,
                    secondClicked.date);

                if (firstClickDateObj > secondClickDateObj) {

                    var cachedClickedInfo = secondClicked;
                    secondClicked = firstClicked;
                    firstClicked = cachedClickedInfo;
                    selected = {};
                    selected[firstClicked.year] = {};
                    selected[firstClicked.year][firstClicked.month] = [firstClicked.date];

                } else if (firstClickDateObj.getTime() ==
                    secondClickDateObj.getTime()) {
                    selected = {};
                    firstClicked = [];
                    secondClicked = [];
                    firstClick = false;
                    secondClick = false;
                    $(this).removeClass("selected");
                }


                // add between dates to [selected]
                selected = addChosenDates(firstClicked, secondClicked, selected);
            }
            selectDates(selected);
        });

    }


    function selectDates(selected) {
        if (!$.isEmptyObject(selected)) {
            var dateElements1 = datesBody1.find('div');
            var dateElements2 = datesBody2.find('div');

            function highlightDates(passed_year, passed_month, dateElements) {
                if (passed_year in selected && passed_month in selected[passed_year]) {
                    var daysToCompare = selected[passed_year][passed_month];
                    for (var d in daysToCompare) {
                        dateElements.each(function (index) {
                            if (parseInt($(this).text()) == daysToCompare[d]) {
                                $(this).addClass('selected');
                            }
                        });
                    }

                }
            }

            highlightDates(year, month, dateElements1);
            highlightDates(nextYear, nextMonth, dateElements2);
        }
    }

    function makeMonthArray(passed_month, passed_year) { // creates Array specifying dates and weekdays
        var e = [];
        for (var r = 1; r < getDaysInMonth(passed_year, passed_month) + 1; r++) {
            e.push({
                day: r,
                // Later refactor -- weekday needed only for first week
                weekday: daysArray[getWeekdayNum(passed_year, passed_month, r)]
            });
        }
        return e;
    }

    function makeWeek(week) {
        week.empty();
        for (var e = 0; e < 7; e++) {
            week.append("<div>" + daysArray[e].substring(0, 3) + "</div>")
        }
    }

    function getDaysInMonth(currentYear, currentMon) {
        return (new Date(currentYear, currentMon + 1, 0)).getDate();
    }

    function getWeekdayNum(e, t, n) {
        let num = (new Date(e, t, n)).getDay() - 1;
        return num < 0 ? 6 : num;
    }

    function checkToday(e) {
        var todayDate = today.getFullYear() + '/' + (today.getMonth() + 1) + '/' + today.getDate();
        var checkingDate = e.getFullYear() + '/' + (e.getMonth() + 1) + '/' + e.getDate();
        return todayDate == checkingDate;

    }

    function getAdjacentMonth(curr_month, curr_year, direction) {
        var theNextMonth;
        var theNextYear;
        if (direction == "next") {
            theNextMonth = (curr_month + 1) % 12;
            theNextYear = (curr_month == 11) ? curr_year + 1 : curr_year;
        } else {
            theNextMonth = (curr_month == 0) ? 11 : curr_month - 1;
            theNextYear = (curr_month == 0) ? curr_year - 1 : curr_year;
        }
        return [theNextMonth, theNextYear];
    }

    function b() {
        today = new Date;
        sNextYear = today.getFullYear();
        sNextMonth = today.getMonth();
        var nextDates = getAdjacentMonth(sNextMonth, sNextYear, "previous");
        nextMonth = nextDates[0];
        nextYear = nextDates[1];
        var nextDates = getAdjacentMonth(nextMonth, nextYear, "previous");
        month = nextDates[0];
        year = nextDates[1];

        let firstMonths = ''
        firstMonths += i[month]
        if (firstMonths !== 'Septembre') {
            firstMonths += ' ' + year
        }
        pMonthsShower.text(
            firstMonths + ' - ' + i[sNextMonth] + ' ' + sNextYear
        )
        let indexMonth = month + 1
        pMonthsShower.attr('data-month', year + '-' + indexMonth)
    }


    function monthsShower(cal, btn) {
        let months = []
        let year = 2021
        cal.each(function () {
            months.push($(this).find('h2').text())
        })
        if (months[0].indexOf('Septembre') >= 0) {
            months[0] = (months[0].split(' '))[0]
        }
        year = (months[0].split(' '))[1]
        pMonthsShower.text(months[0] + ' - ' + months[2])
        let indexMonth = i.indexOf((months[0].split(' '))[0]) + 1
        pMonthsShower.attr('data-month', year + '-' + indexMonth)
    }

    function BtnLoading(btn) {
        btn.attr('data-text', btn.text())
        btn.html('<i class="spinner-border spinner-border-sm"></i>')
    }
    function BtnReset(btn) {
        btn.text(btn.attr('data-text'))
        btn.removeAttr('data-text')
    }

    function loadIncident(e) {
        e.preventDefault()
        let btn = $(this)
        BtnLoading(btn)

        incidentLoader(btn)
    }

    function incidentLoader(btn, contentReload = false, day = null) {
        let data = {}
        if (day !== null) {
            data.day = day
            data.serviceId = $('.status-select-date').val()
        } else {
            data.startedMonth = $('.months-shower').attr('data-month')
            data.lastId = contentReload ? null : $('.incident').last().attr('data-id')
            data.lastMonth = contentReload ? null : $('.incident').last().attr('data-month')
            data.serviceId = $('.status-select-list').val()
        }
        if (contentReload) {
            data.contentReload = true;
        }

        console.log(ajaxRoute, data)
        $.get(ajaxRoute, data).then(function (response) {
            if (btn !== null) {
                BtnReset(btn)
            }
            $('.container-reload-loading').hide()
            if (contentReload) {
                $('.ajax-load-container').html(response)
                $('.non-ajax-loaded').remove()
            } else {
                $('.ajax-load-container').append(response)
            }

            let viewLoaded = $('.loaded-by-ajax')
            if (!contentReload) {
                window.scrollBy(window.scrollX, viewLoaded.height())
            }
            if (viewLoaded.find('.incident').length < 5) {
                $('.btn-loader').hide('slow')
            } else {
                $('.btn-loader').show('slow')
            }
            setTimeout(function () {
                viewLoaded.removeClass('loaded-by-ajax')
                viewLoaded.removeClass('font-weight-bold')
                $('.container-reload-loading').hide()
            }, 1000)
        })
    }
    /**********************End functions**********************************/




    /************************Incidents Panel***************************/

    $('.btn-loader').on('click', loadIncident)
    $('.content-reloader').on('click', loadIncident)
    $('.status-select-list').on('change', function () {
        $('.container-reload-loading').fadeIn(1000)
        incidentLoader(null, true)
    })

    /*********************End Incidents Panel**************************/




    /*********************Temps de disponibilité Panel**************************/
    var e = 480;

    var today;
    var year,
        month,
        nextMonth,
        nextYear,
        sNextMonth,
        sNextYear;

    //var t=2013;
    //var n=9;
    var r = [];
    var i = ["Janvier", "Fevrier", "Mars", "Avril", "Mai",
        "Juin", "Juillet", "Août", "Septembre", "Octobre",
        "Novembre", "Decembre"];
    var daysArray = ["Dimanche", "Lundi", "Mardi",
        "Mercredi", "Jeudi", "Vendredi", "Samedi"];
    var o = ["#16a085", "#1abc9c", "#c0392b", "#27ae60",
        "#FF6860", "#f39c12", "#f1c40f", "#e67e22",
        "#2ecc71", "#e74c3c", "#d35400", "#2c3e50"];

    var cal1 = $("#calendar_first");
    var calHeader1 = cal1.find(".calendar_header");
    var weekline1 = cal1.find(".calendar_weekdays");
    var datesBody1 = cal1.find(".calendar_content");

    var cal2 = $("#calendar_second");
    var calHeader2 = cal2.find(".calendar_header");
    var weekline2 = cal2.find(".calendar_weekdays");
    var datesBody2 = cal2.find(".calendar_content");

    var cal3 = $("#calendar_third");
    var calHeader3 = cal3.find(".calendar_header");
    var weekline3 = cal3.find(".calendar_weekdays");
    var datesBody3 = cal3.find(".calendar_content");

    var bothCals = $(".calendar");

    var switchButton = $('.switch-month');

    var calendars = {
        "cal1": {
            "name": "first",
            "calHeader": calHeader1,
            "weekline": weekline1,
            "datesBody": datesBody1
        },
        "cal2": {
            "name": "second",
            "calHeader": calHeader2,
            "weekline": weekline2,
            "datesBody": datesBody2
        },
        "cal3": {
            "name": "third",
            "calHeader": calHeader3,
            "weekline": weekline3,
            "datesBody": datesBody3
        }
    }


    var clickedElement;
    var firstClicked,
        secondClicked,
        thirdClicked;
    var firstClick = false;
    var secondClick = false;
    var selected = {};

    b();
    c(month, year, 0);
    c(nextMonth, nextYear, 1);
    c(sNextMonth, sNextYear, 2);
    switchButton.on("click", function (e) {
        var clicked = $(this);
        var generateCalendars = function (e) {
            var nextDatesFirst = getAdjacentMonth(month, year, e);
            var nextDatesSecond = getAdjacentMonth(nextMonth, nextYear, e);
            var nextDatesThird = getAdjacentMonth(sNextMonth, sNextYear, e);

            month = nextDatesFirst[0];
            year = nextDatesFirst[1];

            nextMonth = nextDatesSecond[0];
            nextYear = nextDatesSecond[1];

            sNextMonth = nextDatesThird[0];
            sNextYear = nextDatesThird[1];

            c(month, year, 0);
            c(nextMonth, nextYear, 1);
            c(sNextMonth, sNextYear, 2);
        };
        if (clicked.attr("class").indexOf("left") != -1) {
            generateCalendars("previous");
        } else {
            generateCalendars("next");
        }
        clickedElement = bothCals.find(".calendar_content").find("div");

        monthsShower(bothCals, switchButton)
        // TODO: mettre en place une requête pour charger le pourcentage de chaque mois
        if (clicked.hasClass('switch-list')) {
            $('.container-reload-loading').fadeIn(1000)
            incidentLoader(null, true)
        }
    });


    //  Click picking stuff
    function getClickedInfo(element, calendar) {
        var clickedInfo = {};
        var clickedCalendar,
            clickedMonth,
            clickedYear;
        clickedCalendar = calendar.name;
        clickedMonth = clickedCalendar == "first" ? month : nextMonth;
        clickedYear = clickedCalendar == "first" ? year : nextYear;
        clickedInfo = {
            "calNum": clickedCalendar,
            "date": parseInt(element.text()),
            "month": clickedMonth,
            "year": clickedYear
        }
        return clickedInfo;
    }


    // Finding between dates MADNESS. Needs refactoring and smartening up :)
    function addChosenDates(firstClicked, secondClicked, selected) {
        if (secondClicked.date > firstClicked.date ||
            secondClicked.month > firstClicked.month ||
            secondClicked.year > firstClicked.year) {

            var added_year = secondClicked.year;
            var added_month = secondClicked.month;
            var added_date = secondClicked.date;

            if (added_year > firstClicked.year) {
                // first add all dates from all months of Second-Clicked-Year
                selected[added_year] = {};
                selected[added_year][added_month] = [];
                for (var i = 1;
                    i <= secondClicked.date;
                    i++) {
                    selected[added_year][added_month].push(i);
                }

                added_month = added_month - 1;
                while (added_month >= 0) {
                    selected[added_year][added_month] = [];
                    for (var i = 1;
                        i <= getDaysInMonth(added_year, added_month);
                        i++) {
                        selected[added_year][added_month].push(i);
                    }
                    added_month = added_month - 1;
                }

                added_year = added_year - 1;
                added_month = 11; // reset month to Dec because we decreased year
                added_date = getDaysInMonth(added_year, added_month); // reset date as well

                // Now add all dates from all months of inbetween years
                while (added_year > firstClicked.year) {
                    selected[added_year] = {};
                    for (var i = 0; i < 12; i++) {
                        selected[added_year][i] = [];
                        for (var d = 1; d <= getDaysInMonth(added_year, i); d++) {
                            selected[added_year][i].push(d);
                        }
                    }
                    added_year = added_year - 1;
                }
            }

            if (added_month > firstClicked.month) {
                if (firstClicked.year == secondClicked.year) {
                    selected[added_year][added_month] = [];
                    for (var i = 1;
                        i <= secondClicked.date;
                        i++) {
                        selected[added_year][added_month].push(i);
                    }
                    added_month = added_month - 1;
                }
                while (added_month > firstClicked.month) {
                    selected[added_year][added_month] = [];
                    for (var i = 1;
                        i <= getDaysInMonth(added_year, added_month);
                        i++) {
                        selected[added_year][added_month].push(i);
                    }
                    added_month = added_month - 1;
                }
                added_date = getDaysInMonth(added_year, added_month);
            }

            for (var i = firstClicked.date + 1;
                i <= added_date;
                i++) {
                selected[added_year][added_month].push(i);
            }
        }
        return selected;
    }
    /*******************End Temps de disponibilité Panel************************/

});
